import { useLogto } from '@logto/react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../contexts/ThemeContext';

/**
 * No branded login page. This route exists only as a redirect target for
 * ProtectedRoute when the user is unauthenticated. It immediately bounces to
 * Logto's hosted sign-in UI (which is also where sign-up happens), or back
 * home if the user is somehow already authed.
 */
export function Login() {
  const { signIn, isAuthenticated, isLoading } = useLogto();
  const { theme } = useTheme();
  const { t } = useTranslation();

  useEffect(() => {
    if (isLoading) return;
    if (isAuthenticated) {
      window.location.replace('/');
      return;
    }
    void signIn(`${window.location.origin}/callback`);
  }, [signIn, isAuthenticated, isLoading]);

  return (
    <div className={`app theme-${theme}`}>
      <div className="loading-screen">{t('signingIn')}</div>
    </div>
  );
}
